import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { Button } from "@/components/Button";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_MD } from "@/core/media";
import { Flex } from "@/eworkitComponents";

import emptyWorkstylesImg from "./assets/empty-workstyles.svg";

interface IEmptyWorkStylesProps {
  setEditMode: () => void;
}

export const EmptyWorkStyles: FunctionComponent<IEmptyWorkStylesProps> = ({ setEditMode }) => {
  const { t } = useTranslation("session");
  const isMediumScreen = useMedia(MEDIA_SIZE_MD);

  return (
    <Flex direction="column" align="center" justify="center" innerMargin="md">
      <Flex padding={[false, false, "md", false]}>
        <img src={emptyWorkstylesImg} width={isMediumScreen ? 308 : 520} height={124} />
      </Flex>
      <Text size="md" color="grey1" align="center">
        {t("CONSULTANT_PROFILES.DETAIL.WORK_STYLES.EMPTY_DESCRIPTION")}
      </Text>
      <Button onClick={setEditMode} icon="edit">
        {t("CONSULTANT_PROFILES.DETAIL.WORK_STYLES.EDIT_BUTTON")}
      </Button>
    </Flex>
  );
};
